import { debounce } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { encodeQuery, decodeQuery } from '../../services/search-page-url';
import { replace } from '../../services/router-utils';
import SearchInput from '../../components/search-input';
import HeaderWidget from '../header-widget';

const DEBOUNCE_WAIT = 200;

export class SearchHeader extends Component {
  handleQueryChange = debounce(query => this.props.onQueryChange(query), DEBOUNCE_WAIT);

  render() {
    const {
      component: Component,
      left,
      query,
      inputClassName,
      iconClassName,
      borderClassName,
      showWidget,
      ...props
    } = this.props;

    const searchInput = (
      <SearchInput
        isExpanded
        isFullWidth={!showWidget}
        value={query}
        onChange={this.handleQueryChange}
        inputClassName={inputClassName}
        iconClassName={iconClassName}
        borderClassName={borderClassName}
      />
    );

    return (
      <Component left={left} right={showWidget ? <HeaderWidget searchInput={searchInput} /> : searchInput} {...props} />
    );
  }
}

SearchHeader.propTypes = {
  component: PropTypes.any,
  left: PropTypes.node,
  query: PropTypes.string.isRequired,
  onQueryChange: PropTypes.func.isRequired,
  borderClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  iconClassName: PropTypes.string,
  showWidget: PropTypes.bool,
};

SearchHeader.defaultProps = {
  showWidget: true,
};

const mapStateToProps = (state, ownProps) => ({
  query: decodeQuery(ownProps.params.query || ''),
});

const mapDispatchToProps = {
  onQueryChange: query => replace(`/search/${encodeQuery(query)}`),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SearchHeader);
